import React from 'react';
import PropTypes from 'prop-types';
import ToolbarButton from './ToolbarButton';

const hasMark = (value, type) => value.activeMarks.some((mark) => mark.type === type);

const onClickMark = (event, type, editor) => {
  event.preventDefault();
  editor.toggleMark(type);
};

const ToolbarMarkButton = ({
  editor, type, icon, onClick, label,
}) => {
  const isActive = editor && hasMark(editor.value, type);
  return (
    <ToolbarButton
      isActive={isActive}
      onClick={(event) => onClick(event, type, editor)}
      icon={icon}
      label={label}
    />
  );
};
ToolbarMarkButton.propTypes = {
  editor: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  label: PropTypes.string,
};
ToolbarMarkButton.defaultProps = {
  onClick: onClickMark,
  label: '',
};

export default ToolbarMarkButton;
